import { classNamePrefix as prefixCt } from "@/utils/common";
import "../index.less";

export default class noteRender {
  fragmentCls: string;

  config: Record<string, any>;

  constructor(config = {}) {
    this.fragmentCls = `.${prefixCt("note")}`;
    this.config = config;
  }

  fragmentRender = (node: HTMLElement) => {
    Array.from(node.children).forEach((child) => {
      if (child.innerHTML.trim() === "") {
        node.removeChild(child);
      }
    });
  };
}
